var map = {
	"./default.js": "+OT3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+FVz";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/config ^\.\/.*\.js$
// module id = +FVz
// module chunks = 20